import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  TextField,
  Typography,
  CircularProgress,
  Divider
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { useDispatch } from 'react-redux';
import { updateStaffPassword } from 'src/store/actions/StaffActions';

function UpdatePassword({ handleClose }) {
  const profile = JSON.parse(sessionStorage.getItem('profile'));
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();

  const handleUpdatePassword = async (values) => {
    setLoading(true);
    const response = await dispatch(updateStaffPassword(values, profile));
    if (response == 1) {
      handleClose();
      setLoading(false);
    } else {
      setLoading(false);
    }
  };

  return (
    <Formik
      initialValues={{
        oldPassword: '',
        newPassword: ''
      }}
      validationSchema={Yup.object().shape({
        oldPassword: Yup.string().max(255).required('Old Password is required'),
        newPassword: Yup.string().max(255).required('New Password is required')
      })}
      onSubmit={(values) => {
        handleUpdatePassword(values);
        // navigate('/app/dashboard', { replace: true });
      }}
    >
      {({
        errors,
        handleBlur,
        handleChange,
        handleSubmit,
        touched,
        values
      }) => (
        <form onSubmit={handleSubmit}>
          <DialogContent>
            <TextField
              error={Boolean(touched.oldPassword && errors.oldPassword)}
              fullWidth
              helperText={touched.oldPassword && errors.oldPassword}
              label="Old Password"
              margin="normal"
              name="oldPassword"
              onBlur={handleBlur}
              onChange={handleChange}
              type="password"
              value={values.oldPassword}
              variant="outlined"
              size="small"
            />
            <TextField
              error={Boolean(touched.newPassword && errors.newPassword)}
              fullWidth
              helperText={touched.newPassword && errors.newPassword}
              label="New Password"
              margin="normal"
              name="newPassword"
              onBlur={handleBlur}
              onChange={handleChange}
              type="password"
              value={values.newPassword}
              variant="outlined"
              size="small"
            />
          </DialogContent>
          <DialogActions>
            <Button variant="outlined" onClick={handleClose}>
              Close
            </Button>
            <Button
              disabled={loading}
              variant="contained"
              color="primary"
              type="submit"
            >
              {loading && <CircularProgress size="1.5rem" />}
              &nbsp; Update
            </Button>
          </DialogActions>
        </form>
      )}
    </Formik>
  );
}

export default UpdatePassword;
